import { useEffect, useState } from "react";
import Filter from "./Filter";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { ReservationPaymentList } from "../../../types/common.types";
import List from "./List";
import formatNumberToString from "../../../utils/formatNumber";
import { useGlobal } from "../../../context/global";

interface Accounting {
    total_price: number;
    total_tickets: number;
    total_tarjeta: number;
    total_efectivo: number;
    total_transferencia: number;
    total_deuda: number;
    total_wise: number;
}

export default function Sales() {
    const { setIsLoading } = useGlobal()
    const { currentDay, endDay, viewPaymentsData, sellerId, setSellerId } = useAdmin()
    const [sales, setSales] = useState<ReservationPaymentList[]>([])

    const [account, setAccount] = useState<Accounting>({} as Accounting)

    useEffect(() => {
        async function fetchSales() {
            setIsLoading(true)
            try {
                if (!currentDay || !sellerId) return
                const data = await (await AdminService.listSalesByDay(currentDay, sellerId, endDay)).data
                setSales(data.reservations)
                setAccount(data.account)
                console.log(data);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false)
            }
        }
        fetchSales()
    }
    , [currentDay, endDay, sellerId, viewPaymentsData])

    
    return (
        <>
            <Filter setSelectedSeller={setSellerId}/>
            <div className="pdf-print">
                {/* <button
                    // onClick={printSales}
                    className="btn btn-primary"
                    style={{marginBottom: '20px', backgroundColor: '#4087f1', color: '#fff', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer'}}
                >
                    Print
                </button> */}
            </div>
            <div className="accounting" style={{display: 'flex', textAlign: 'center', flexWrap: 'wrap', gap: '10px'}}>
                {Object.entries(account).map(([key, value]) => (
                    <div key={key} className="accounting-item">
                    <span>
                        {key.split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}:
                    </span>
                    <span>
                        {
                        formatNumberToString(Number(value))
                        }
                    </span>
                    </div>
                ))}
            </div>
            <List data={sales}/>
        </>
    )
}